import React, { FC, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { FormComponentProps, FormProps } from 'antd/lib/form/Form';
import {
    Layout, Form, Icon, Input, Button, Modal,
} from 'antd';

import '../../assets/styles/App.less';
import '../../assets/styles/Register.less';
import { getErrorMessageFromState } from '../../utils';
import { AuthState, resetPassword, getResetPasswordState } from '../../store/actions/auth';
import { MainReducerState } from '../../store/reducers';

interface MatchParams {
    token?: string;
}

interface ResetPasswordProps extends RouteComponentProps<MatchParams>, FormComponentProps {
    onPasswordReset: typeof resetPassword.trigger;
    passwordResetState: AuthState['resetPassword'];
}

const ResetPassword: FC<ResetPasswordProps> = ({ form, passwordResetState, onPasswordReset, match }) => {
    const { getFieldDecorator, getFieldValue } = form;
    const [isRedirectNow, setRedirectNow] = useState(false);

    useEffect(() => {
        if (passwordResetState.success) {
            Modal.info({
                title: 'Votre mot de passe à été modifié',
                content: (
                    <div>
                        <p>Vous pouvez maintenant vous connecter.</p>
                    </div>
                ),
                onOk() {
                    setRedirectNow(true);
                },
            });
        }
    }, [passwordResetState.success]);

    const onFormSubmit: FormProps['onSubmit'] = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            const params: any = {
                password: getFieldValue('password'),
                token: match.params.token,
            };
            onPasswordReset(params);
        });
    };

    return (
        <Layout id="register-layout">
            <Layout.Content>
                <header>
                    <h3>Choisissez un nouveau mot de passe</h3>
                </header>
                <Form onSubmit={onFormSubmit} className="register-form">
                    <Form.Item>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: 'Entrez un mot de passe svp!' }],
                        })((
                            <Input.Password
                                prefix={<Icon type="lock" />}
                                placeholder="Mot de passe"
                            />
                        ))}
                    </Form.Item>
                    {getErrorMessageFromState(passwordResetState) ? (
                        <div className="login-error has-error">
                            <span className="ant-form-explain">{getErrorMessageFromState(passwordResetState)}</span>
                        </div>
                    ) : null}
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                        >
                            Ré-initialiser mon mot de passe
                        </Button>
                    </Form.Item>
                </Form>
                {isRedirectNow && (
                    <Redirect to="/login" />
                )}
            </Layout.Content>
        </Layout>
    );
};

const mapStateToProps = (state: MainReducerState) => ({
    passwordResetState: getResetPasswordState(state),
});

const ResetPasswordForm = Form.create()(ResetPassword);

export default connect(
    mapStateToProps,
    {
        onPasswordReset: resetPassword.trigger,
    },
)(ResetPasswordForm);
